(function () {
  var STROKE_COLOR = "#6A6D52";
  var DASH_PATTERN = "2 4";
  var STROKE_WIDTH = 1.5;
  var SPACING = 10; // gap between circle edge and line start/end
  var CORNER_RADIUS = 16; // corner radius on the C-curve
  var SVG_NS = "http://www.w3.org/2000/svg";

  function circleCenter(el, containerRect) {
    var rect = el.getBoundingClientRect();
    return {
      x: rect.left + rect.width / 2 - containerRect.left,
      y: rect.top + rect.height / 2 - containerRect.top,
      radius: rect.width / 2,
    };
  }

  function makePath(d, markerId) {
    var path = document.createElementNS(SVG_NS, "path");
    path.setAttribute("d", d);
    path.setAttribute("fill", "none");
    path.setAttribute("stroke", STROKE_COLOR);
    path.setAttribute("stroke-width", STROKE_WIDTH);
    path.setAttribute("stroke-dasharray", DASH_PATTERN);
    path.setAttribute("stroke-linecap", "round");
    path.setAttribute("marker-end", "url(#" + markerId + ")");
    return path;
  }

  function draw(timeline, markerId) {
    // Remove previous SVG
    var existingSvg = timeline.querySelector(".process__connectors");
    if (existingSvg) existingSvg.remove();

    // Desktop only
    if (window.innerWidth <= 769) return;

    var circles = Array.from(timeline.querySelectorAll(".process__circle"));
    if (circles.length < 2) return;

    var timelineRect = timeline.getBoundingClientRect();
    var centers = circles.map(function (el) {
      return circleCenter(el, timelineRect);
    });

    var svg = document.createElementNS(SVG_NS, "svg");
    svg.setAttribute("class", "process__connectors");
    svg.style.cssText =
      "position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;overflow:visible;z-index:0;";

    // ── Arrow marker (orient=auto: rotates with path direction) ──
    var defs = document.createElementNS(SVG_NS, "defs");
    var marker = document.createElementNS(SVG_NS, "marker");
    marker.setAttribute("id", markerId);
    marker.setAttribute("markerWidth", "12");
    marker.setAttribute("markerHeight", "10");
    marker.setAttribute("refX", "9");
    marker.setAttribute("refY", "5");
    marker.setAttribute("orient", "auto");
    marker.setAttribute("markerUnits", "userSpaceOnUse");
    var arrowShape = document.createElementNS(SVG_NS, "path");
    // Filled chevron pointing right — outer tip → top wing → inner notch → bottom wing → close
    arrowShape.setAttribute("d", "M 9 5 L 4 1 L 4 2.3 L 7 5 L 4 7.7 L 4 9 Z");
    arrowShape.setAttribute("fill", STROKE_COLOR);
    arrowShape.setAttribute("stroke", "none");
    marker.appendChild(arrowShape);
    defs.appendChild(marker);
    svg.appendChild(defs);

    // ── Row 1 horizontal connectors (circles 0→1, 1→2) ──────────
    for (var i = 0; i < 2; i++) {
      var from = centers[i],
        to = centers[i + 1];
      svg.appendChild(
        makePath(
          "M " +
            (from.x + from.radius + SPACING) +
            " " +
            from.y +
            " L " +
            (to.x - to.radius - SPACING) +
            " " +
            to.y,
          markerId,
        ),
      );
    }

    // ── Routed path through tier label ───────────────────────────
    if (centers.length >= 4) {
      var tierEl = timeline.querySelector(".process__tier-label");
      var row1Last = centers[2];
      var row2First = centers[3];
      var rightEdge = timelineRect.width - 2;

      if (tierEl) {
        var tierRect = tierEl.getBoundingClientRect();
        var tierRight = tierRect.right - timelineRect.left;
        var tierLeft = tierRect.left - timelineRect.left;
        var tierMidY = tierRect.top - timelineRect.top + tierRect.height / 2;

        // Segment A: circle 3 → right edge → tier label right
        // Path ends going LEFT → orient=auto gives ← at tier label
        svg.appendChild(
          makePath(
            [
              "M",
              row1Last.x + row1Last.radius + SPACING,
              row1Last.y,
              "L",
              rightEdge - CORNER_RADIUS,
              row1Last.y,
              "A",
              CORNER_RADIUS,
              CORNER_RADIUS,
              0,
              0,
              1,
              rightEdge,
              row1Last.y + CORNER_RADIUS, // → turns ↓  (CW)
              "L",
              rightEdge,
              tierMidY - CORNER_RADIUS,
              "A",
              CORNER_RADIUS,
              CORNER_RADIUS,
              0,
              0,
              1,
              rightEdge - CORNER_RADIUS,
              tierMidY, // ↓ turns ←  (CW)
              "L",
              tierRight,
              tierMidY,
            ].join(" "),
            markerId,
          ),
        );

        // Segment B: tier label left → left edge → circle 4
        // Path ends going RIGHT → orient=auto gives → at circle 4
        svg.appendChild(
          makePath(
            [
              "M",
              tierLeft,
              tierMidY,
              "L",
              CORNER_RADIUS,
              tierMidY,
              "A",
              CORNER_RADIUS,
              CORNER_RADIUS,
              0,
              0,
              0,
              0,
              tierMidY + CORNER_RADIUS, // ← turns ↓  (CCW)
              "L",
              0,
              row2First.y - CORNER_RADIUS,
              "A",
              CORNER_RADIUS,
              CORNER_RADIUS,
              0,
              0,
              0,
              CORNER_RADIUS,
              row2First.y, // ↓ turns →  (CCW)
              "L",
              row2First.x - row2First.radius - SPACING,
              row2First.y,
            ].join(" "),
            markerId,
          ),
        );
      }
    }

    // ── Row 2 horizontal connectors (circles 3→4, 4→5, 5→6) ─────
    var row2LastIndex = Math.min(centers.length - 1, 6);
    for (var j = 3; j < row2LastIndex; j++) {
      var from2 = centers[j],
        to2 = centers[j + 1];
      svg.appendChild(
        makePath(
          "M " +
            (from2.x + from2.radius + SPACING) +
            " " +
            from2.y +
            " L " +
            (to2.x - to2.radius - SPACING) +
            " " +
            to2.y,
          markerId,
        ),
      );
    }

    timeline.appendChild(svg);
  }

  function initTimeline(timeline) {
    var markerId = "process-arrow-" + timeline.dataset.sectionId;
    function redraw() {
      draw(timeline, markerId);
    }
    redraw();
    new ResizeObserver(redraw).observe(timeline);
  }

  document.fonts.ready.then(function () {
    requestAnimationFrame(function () {
      document
        .querySelectorAll(".process__timeline[data-section-id]")
        .forEach(initTimeline);
    });
  });
})();
